export default __webpack_public_path__ + "static/media/truck.89432dff.png";